import styled from 'styled-components'

export const PageTitle = styled.h1`
  color: ${({ theme }) => theme.text1};
  font-size: 24px;
  font-weight: 400;
  line-height: 1.2;
  margin: 0 0 24px 0;
`
